/**
 * Lightweight analytics hook. Wraps a simple event emitter pattern so
 * you can swap in Mixpanel / GA / PostHog later without touching components.
 *
 * Usage:
 *   const { track } = useAnalytics();
 *   track('booking_started', { carId, packageId });
 */

// Global handlers list — register adapters here
const handlers = [];

export function registerAnalyticsHandler(fn) {
  handlers.push(fn);
}

// Console logger in dev
if (import.meta.env.DEV) {
  registerAnalyticsHandler((event, props) => {
    console.log(`[Analytics] ${event}`, props);
  });
}

function track(event, properties = {}) {
  const payload = {
    ...properties,
    timestamp: new Date().toISOString(),
  };
  handlers.forEach((fn) => {
    try {
      fn(event, payload);
    } catch {
      // swallow analytics errors
    }
  });
}

// Pre-defined event names
export const EVENTS = {
  BOOKING_STARTED: "booking_started",
  BOOKING_COMPLETED: "booking_completed",
  PAYMENT_SUCCESS: "payment_success",
  PAYMENT_FAILURE: "payment_failure",
  LOGIN_SUCCESS: "login_success",
  SIGNUP: "signup",
  SERVICE_VIEWED: "service_viewed",
  CAR_ADDED: "car_added",
  REFERRAL_SHARED: "referral_shared",
  SUBSCRIPTION_PURCHASED: "subscription_purchased",
};

export function useAnalytics() {
  return { track, EVENTS };
}
